import React, { useState, useEffect } from 'react'
import { Modal, Button, Form, Alert, Card, Row, Col } from 'react-bootstrap'
import { materialsAPI } from '../../services/api'

const MaterialsModal = ({ show, onHide, work, onUpdate }) => {
  const [materials, setMaterials] = useState([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  useEffect(() => {
    if (show && work) {
      setMaterials(work.materials || [])
    }
  }, [show, work])

  const handleSubmit = async (e) => {
    e.preventDefault()
    const formData = new FormData(e.target)

    try {
      setLoading(true)
      await materialsAPI.create(work.id, formData)
      setError(null)
      e.target.reset()
      // Reload materials
      onUpdate()
    } catch (err) {
      setError('Ошибка при добавлении материала')
      console.error('Error adding material:', err)
    } finally {
      setLoading(false)
    }
  }

  const handleDelete = async (materialId) => {
    if (!window.confirm('Удалить материал?')) {
      return
    }

    try {
      await materialsAPI.delete(work.id, materialId)
      onUpdate()
    } catch (err) {
      setError('Ошибка при удалении материала')
      console.error('Error deleting material:', err)
    }
  }

  const handleClose = () => {
    setError(null)
    onHide()
  }

  if (!work) return null

  return (
    <Modal show={show} onHide={handleClose} size="xl">
      <Modal.Header closeButton className="bg-secondary bg-opacity-10 border-0 pb-3">
        <div className="d-flex flex-column">
          <Modal.Title className="mb-1 fw-bold">
            <i className="bi bi-box-seam me-2"></i>
            Материалы работы
          </Modal.Title>
          <small className="text-muted">{work.work_name}</small>
        </div>
      </Modal.Header>
      <Modal.Body className="p-4">
        {error && <Alert variant="danger" dismissible onClose={() => setError(null)}>{error}</Alert>}

        {/* Список материалов */}
        {materials && materials.length > 0 ? (
          <div className="mb-4">
            <div className="d-flex align-items-center mb-3">
              <i className="bi bi-images fs-5 text-secondary me-2"></i>
              <h6 className="mb-0 fw-semibold">Список материалов</h6>
            </div>
            <Row className="g-3">
              {materials.map((material) => (
                <Col key={material.id} lg={3} md={4} sm={6}>
                  <Card className="h-100 border shadow-sm">
                    {material.photo_url ? (
                      <Card.Img
                        variant="top"
                        src={material.photo_url}
                        style={{ height: '180px', objectFit: 'cover' }}
                        loading="lazy"
                      />
                    ) : (
                      <div
                        className="card-body text-center bg-light d-flex align-items-center justify-content-center"
                        style={{ height: '180px' }}
                      >
                        <div className="text-center">
                          <i className="bi bi-image fs-1 text-muted mb-2"></i>
                          <div className="small text-muted">Без фото</div>
                        </div>
                      </div>
                    )}
                    <Card.Body className="p-3 bg-white">
                      <div className="d-flex flex-column">
                        <h6 className="fw-semibold mb-2" title={material.name}>
                          {material.name}
                        </h6>
                        <Button
                          variant="outline-danger"
                          size="sm"
                          className="w-100"
                          onClick={() => handleDelete(material.id)}
                        >
                          <i className="bi bi-trash me-1"></i>
                          Удалить
                        </Button>
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row>
          </div>
        ) : (
          <Alert variant="light" className="border text-center py-4 mb-4">
            <i className="bi bi-box fs-3 text-muted d-block mb-2"></i>
            <p className="mb-0 text-muted">Материалы еще не добавлены</p>
          </Alert>
        )}

        {/* Форма добавления */}
        <div className="border-top border-2 my-4 pt-4">
          <div className="d-flex align-items-center mb-3">
            <i className="bi bi-plus-circle fs-5 text-success me-2"></i>
            <h6 className="mb-0 fw-semibold">Добавить материал</h6>
          </div>

          <Form onSubmit={handleSubmit} className="bg-light rounded-3 p-4">
            <Form.Group className="mb-3">
              <Form.Label className="fw-semibold d-flex align-items-center mb-2">
                <i className="bi bi-tag me-2"></i>
                Название материала
              </Form.Label>
              <Form.Control
                type="text"
                name="material[name]"
                placeholder="Например: Кирпич керамический М150"
                required
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label className="fw-semibold d-flex align-items-center mb-2">
                <i className="bi bi-camera me-2"></i>
                Фотография
              </Form.Label>
              <Form.Control
                type="file"
                name="material[photo]"
                accept="image/*"
                size="lg"
                required
              />
              <Form.Text className="mt-2">
                <i className="bi bi-info-circle me-1"></i>
                Поддерживаемые форматы: PNG, JPG, JPEG, WEBP
              </Form.Text>
            </Form.Group>
            <div className="d-flex justify-content-end">
              <Button type="submit" variant="primary" disabled={loading} className="px-4">
                <i className="bi bi-plus-lg me-2"></i>
                Добавить материал
              </Button>
            </div>
          </Form>
        </div>
      </Modal.Body>
      <Modal.Footer className="border-0 pt-0 pb-4 px-4">
        <Button variant="outline-secondary" onClick={handleClose}>
          <i className="bi bi-x-lg me-2"></i>
          Закрыть
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default MaterialsModal
